// Module
var code = "<!-- Pill pointer -->\n<div ref=\"pillPointer\" class=\"pill-pointer\"></div>";
// Exports
module.exports = code;